import { createFileRoute } from "@tanstack/react-router";
import { DiscoverSectionPage } from "../../../features/discover/pages/discover-section-page";

/**
 * Liked picks. Canonical is Discover: this is one guest's saved list, empty
 * for everyone else and for a crawler, so it has nothing of its own to index.
 */
export const Route = createFileRoute("/$lang/_layout/liked")({
  component: () => (
    <DiscoverSectionPage
      mode="liked"
      canonicalOf="discover"
      titleKey="discover.seo_title"
      descriptionKey="discover.seo_description"
    />
  ),
});
